<template>
  <div id="leaseagreement">
    <div class="search">
      <div class="cs-searchbar">
        <i class="cs-search"></i>
        <input class="form-control"
          v-clearable
          :placeholder="lang.search"
          @keyup.prevent.enter="search($event.target.value)">
      </div>
    </div>

    <div id="content">
      <div class="flex">
        <h1 class="flex-1">{{ lang.title }}</h1>

        <div class="flex-1 text-right">
          <a @click="onAddClick" class="btn btn-secondary w-50">{{ lang.new_user }}</a>
        </div>
      </div>

      <UserList @columnClick="_setOrderBy($event.key)" :models="pagination.data"/>

      <div text-center>
        <paginate v-if="pagination.last_page"
          v-model="pagination.page"
          :page-count="pagination.last_page"
          :click-handler="_onPageClick"
          :prev-text="i18n.app.pagination.prev"
          :next-text="i18n.app.pagination.next"
          :container-class="'paginator'"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import UserList from './partials/UserList';
  import UserService from '@/services/UserService';
  import paginationMixin from '@/mixins/pagination.mixin';

  const userService = new UserService;

  export default {
    name: 'users',
    components: {
      UserList
    },
    data() {
      return {
        models: [],
        lang: i18n.app.components.users,
        state: {
          search: '',
        },
      }
    },
    mixins: [paginationMixin],
    mounted() {
      this.search();
    },
    methods: {
      onOrderBy(column) {
        this.search(this.state.search);
      },
      onPage() {
        this.search(this.state.search);
      },
      onAddClick() {
        this.$router.push('users/create');
      },
      async search(search = '') {
        userService.search(search, {meta: this.getPaginationPostData()}).then(pagination => {
          this.pagination = pagination;
        });
      },
    }
  }
</script>
